import { render } from "./activityManager.vue?vue&type=template&id=a5e19d62&scoped=true"
import script from "./activityManager.vue?vue&type=script&lang=js"
export * from "./activityManager.vue?vue&type=script&lang=js"

import "./activityManager.vue?vue&type=style&index=0&id=a5e19d62&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e19d62"]])

export default __exports__